(ns frontend.view.modals.components.processing-modal
  (:require
    [common.localization :as loc]
    [frontend.view.modals.components.processing-layer :as processing-layer]
    [frontend.view.modals.components.error-layer :as error-layer]
    [frontend.view.modals.components.success-layer :as success-layer]
    [ui.components.button.view :as button]
    [ui.components.modal.view :as modal]))

(defn start-processing!
  [state]
  (swap! state assoc :process/status :process.status/processing))

(defn success!
  [state]
  (js/setTimeout (fn [_]
                   (swap! state assoc :process/status :process.status/success))
                 100))

(defn error!
  [state failure-response]
  (js/setTimeout (fn [_]
                   (swap! state assoc
                     :process/status :process.status/failed
                     :failure-response failure-response))
                 100))

(defn finished-footer
  [on-close!]
  [button/secondary-hollow
   {:on-click   (fn [e]
                  (on-close!))}
   (loc/tr :close)])

(defn render-modal
  [{:keys [state
           shown?
           on-show!
           on-close!
           class-name
           header-class-name
           header-color
           success-text
           default-title-fn
           default-body-fn
           default-footer-fn]}]
  (let [status (:process/status @state)]
    (when (fn? on-show!)
      (on-show!))
    (fn
      [{:keys [state
               shown?
               on-show!
               on-close!
               class-name
               header-class-name
               header-color
               success-text
               default-title-fn
               default-body-fn
               default-footer-fn]}]
      (let [status (:process/status @state)]
        [modal/view
         {:visible?      shown?
          :hide!         on-close!
          :backdrop      "static"
          :close-button? true
          :color         header-color}
         (default-title-fn)
         [:<>
          (case status
            :process.status/success (success-layer/view state success-text)
            :process.status/failed (if-let [failure-response (:failure-response @state)]
                                     (error-layer/error-response failure-response)
                                     (error-layer/generic-error state))
            :process.status/processing (processing-layer/view state)
            (default-body-fn))]
         [:<>
          (case status
            :process.status/success (finished-footer on-close!)
            :process.status/failed (finished-footer on-close!)
            :process.status/processing nil
            (default-footer-fn))]]))))
